var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rowData)?_c('div',{staticClass:"details-row"},[(_vm.startIcon)?_c(_vm.startIcon,{tag:"component",staticClass:"details-icon"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"details-data"},[_vm._v(_vm._s(_vm.rowData))]),_vm._v(" "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }